import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

interface TemplateProps {
  pageId: number
}
const categoryTitle = '小売/流通/卸'
const baseUrl = '/cases/retail/'

const Template: React.FC<TemplateProps> = ({ pageId }) => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={pageId} />
}

export default Template
